module.exports = __webpack_public_path__ + "static/media/ConversationLogo.04301c0b.svg";